import { LocationQuery, LocationQueryValue } from 'vue-router';

import { useCommonStore } from '@/stores/common/common';

export const hasHowProperties = async (): Promise<boolean> => {
  const commonStore = useCommonStore();
  const properties = await commonStore.fetchUserProperties();

  return Boolean(properties && properties.length > 0);
};

const getSingleQueryValue = (value: LocationQueryValue | LocationQueryValue[]): string => {
  const singleValue = Array.isArray(value) ? value[0] : value;
  return singleValue?.trim() ? singleValue : '';
};

export const getHowSourceFromQuery = (query: LocationQuery): string => {
  return getSingleQueryValue(query.source) || getSingleQueryValue(query.utm_source);
};
